export function shortLead(text: string, max = 155): string {
  const clean = text.replace(/\s+/g, " ").trim();
  if (clean.length <= max) return clean;

  const sentence = clean.match(/^.*?[.!?](\s|$)/)?.[0]?.trim();
  if (sentence && sentence.length <= max) return sentence;

  const cut = clean.lastIndexOf(" ", max - 3);
  return `${clean.slice(0, cut > 60 ? cut : max - 3).trim()}...`;
}

export function firstSentence(text: string): string {
  return text.replace(/\s+/g, " ").trim().match(/^.*?[.!?](\s|$)/)?.[0]?.trim() ?? text.trim();
}
